import { nexusSourceValues } from '@inpart-io/padme-iap';
import { computed, type ComputedRef } from 'vue';
import { useStore } from 'vuex';

import { SESSION_MODULE } from '@/store/session-module';
import { USE_CORTELLIS } from '@/store/session-module/getters';

export function useCortellisHelper(): {
    useCortellis: ComputedRef<boolean>;
    isCortellisEntity: (entity: object) => boolean;
} {
    const store = useStore();

    const useCortellis = computed<boolean>(() => {
        return store.getters[`${SESSION_MODULE}/${USE_CORTELLIS}`];
    });

    const isCortellisEntity = (entity: object): boolean => {
        return (
            ('externalIds' in entity &&
                entity.externalIds instanceof Object &&
                (('cortellis_company_id' in entity.externalIds && entity.externalIds.cortellis_company_id !== null) ||
                    ('cortellis_asset_id' in entity.externalIds && entity.externalIds.cortellis_asset_id !== null) ||
                    ('nexus_asset_id' in entity.externalIds && entity.externalIds.nexus_asset_id !== null))) ||
            ('nexusId' in entity && 'source' in entity && entity?.nexusId !== null && entity?.source === nexusSourceValues.CORTELLIS)
        );
    };

    return { useCortellis, isCortellisEntity };
}
